export default "__VITE_ASSET__pBqrTrZt__"